import { render, staticRenderFns } from "./role-permission.vue?vue&type=template&id=86a28730"
import script from "./role-permission.vue?vue&type=script&lang=js"
export * from "./role-permission.vue?vue&type=script&lang=js"
import style0 from "./role-permission.vue?vue&type=style&index=0&id=86a28730&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports